import React, { useState } from 'react';
import { Navbar, Nav, NavDropdown, Container } from 'react-bootstrap';



const Header = () => {
  const [isNavOpen, setIsNavOpen] = useState(false);
  const [isSearchOpen] = useState(false);


  const toggleNav = () => {
    setIsNavOpen(!isNavOpen);
  };


  return (
    <header className>
      {/* Header Top */}
{/* <div className="header-top bgg-darkk py-md-2 text-center">
  <div className="container">
    <div className="row justify-content-center">
      <div className="col-12">
        <div className="header-top-contact">
          <ul className="anchor d-flex justify-content-center align-items-center gap-4 mb-0">
            <li className="fw-bold">
              <a className="text-white" href="tel:+917387507373">
                <i className="fas fa-phone-volume me-2"></i>
                +91 7387507373
              </a>
            </li>
             <li className="fw-bold">
              <a className="text-white" href="tel:+919595532929">
                <i className="fas fa-phone-volume me-2"></i>
                +91 9595532929
              </a>
            </li>

            <li className="fw-bold">
              <a className="text-white" href="mailto:booking@sanavitravels.com">
                <i className="far fa-envelope me-2"></i>
                booking@sanavitravels.com
              </a>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</div> */}


<div className="header-top bgg-darkk py-md-2 text-center">
  <div className="container">
    <div className="row justify-content-center">
      <div className="col-12">
        <div className="header-top-contact">
          <ul className="
            anchor
            d-flex
            flex-column
            flex-md-row
            justify-content-center
            align-items-center
            gap-2
            gap-md-4
            mb-0
          ">
            <li className="fw-bold">
              <a className="text-white" href="tel:+917387507373">
                <i className="fas fa-phone-volume me-2"></i>
                +91 7387507373
              </a>
            </li>

            <li className="fw-bold">
              <a className="text-white" href="tel:+919595532929">
                <i className="fas fa-phone-volume me-2"></i>
                +91 9595532929
              </a>
            </li>

            <li className="fw-bold">
              <a className="text-white" href="mailto:booking@sanavitravels.com">
                <i className="far fa-envelope me-2"></i>
                booking@sanavitravels.com
              </a>
            </li>
               <a href="https://www.facebook.com/profile.php?id=61583046933009">
                    <i className="fab fa-facebook-f text-white"></i>
                  </a>
                  <a href="https://x.com/sanavitravels/">
                    <i className="fab fa-twitter text-white"></i>
                  </a>
                  <a href="https://www.instagram.com/sanavi_travels/">
                    <i className="fab fa-instagram text-white"></i>
                  </a>
                 <a href="https://in.pinterest.com/sanavitravelscom/">
  <i className="fab fa-pinterest text-white"></i>
</a>
          </ul>
          
        </div>
      </div>
    </div>
  </div>
</div>



      {/* Main Navigation */}
      <div className="main-navigation">
        <Navbar expand="lg">
          <Container>
            <img src="/images/logo.jpg" className='logoo' alt="logo" />
            <Navbar.Toggle aria-controls="main_nav" onClick={toggleNav}>
              <i className="fas fa-bars darkcolorr"></i> 
            </Navbar.Toggle>

            <Navbar.Collapse id="main_nav" className={isNavOpen ? "show" : ""}>
              <Nav className="mx-auto">
                <Nav.Link href="/" className='fw-bold nav-item'>Home</Nav.Link>
                <NavDropdown title="About Us" id="about-us-dropdown" className='fw-bold'>
                  <NavDropdown.Item href="/about" className='fw-bold nav-item'>About Us</NavDropdown.Item>
                  <NavDropdown.Item href="/term-condition" className='fw-bold nav-item'>Term & Condition</NavDropdown.Item>
                  <NavDropdown.Item href="/privacy-policy" className='fw-bold '>Privacy Policy</NavDropdown.Item>
                 
                </NavDropdown>
                <Nav.Link href="/services" className='fw-bold nav-item'>Services</Nav.Link>
                <Nav.Link href="/our-fleet" className='fw-bold nav-item'>Our Fleet</Nav.Link>
                <Nav.Link href="/packages" className='fw-bold nav-item'>Packages</Nav.Link>
                <Nav.Link href="/network" className='fw-bold nav-item'>Our Network</Nav.Link>
                <Nav.Link href="/booking" className='fw-bold nav-item'>Online Booking</Nav.Link>
                <Nav.Link href="/gallery" className='fw-bold nav-item'>Gallery</Nav.Link>
                <NavDropdown title="Contact Us" id="contact-dropdown" className='fw-bold'>
                  <NavDropdown.Item href="/contact-us" className='fw-bold nav-item'>Contact Us</NavDropdown.Item>
                  <NavDropdown.Item href="/enquiry" className='fw-bold'>Enquiry</NavDropdown.Item>
                </NavDropdown>
              </Nav>
           
            </Navbar.Collapse>
            
          </Container>
         
        </Navbar>
      </div>

      {/* Search Area */}
      {isSearchOpen && (
        <div className="search-area">
          <form action="#">
            <div className="form-group">
              <input type="text" className="form-control" placeholder="Type Keyword..." />
              <button type="submit" className="search-icon-btn">
                <i className="far fa-search"></i>
              </button>
            </div>
          </form>
        </div>
      )}
    </header>
  );
};

export default Header;

